module.exports = __webpack_public_path__ + "static/media/trash_grey.e54346b1.svg";